<template>
<main class="sl-home sl-home-video home-container">
  <header class="sl-topbar"><div class="sl-brand"><img src="/sweetlove-logo.png" alt="SweetLove" /></div><button v-if="!is_login" class="sl-quiet-button" type="button" @click="$router.push('/Register')">{{ $t('auth.no_account') }}<sl-icon name="arrow" /></button><span v-else class="sl-top-label">{{ $t('foorter.index') }}</span></header>
  <div class="home-scroll">
    <section class="sl-hero sl-home-hero"><div><p class="sl-eyebrow">SWEETLOVE · {{ $t('index.Featured_list') }}</p><h1>{{ $t('foorter.index') }}</h1><p class="sl-hero-caption"><span class="sl-live-dot"></span>{{ topNav[activeNav] ? topNav[activeNav].name : $t('foorter.index') }}<span class="sl-caption-line"></span>{{ videoCount || xuan_fei.length }} 部視頻</p></div><div class="sl-hero-orbit" aria-hidden="true"><sl-icon name="play" /></div></section>
    <nav class="top-nav sl-category-nav" aria-label="視頻分類"><div v-for="(item,index) in topNav" :key="item.id || index" :class="['nav-item',{active:activeNav===index}]"><button type="button" :aria-pressed="activeNav===index" @click="setActiveNav(index)">{{ item.name }}</button><button v-if="item.subItems && item.subItems.length && activeNav===index" class="sl-dropdown" type="button" aria-label="展開分類" :aria-expanded="showCategories" @click.stop="toggleDropdown(index)"><van-icon name="arrow-down" /></button></div></nav>
    <div v-if="showCategories" class="category-tabs sl-child-categories"><button v-for="(category,index) in currentCategories" :key="category.id || index" type="button" :class="['category-item',{active:activeCategory===index}]" @click="setActiveCategory(index)">{{ category.name }}</button></div>
    <div class="sl-section-heading sl-home-list-heading"><div><p class="sl-eyebrow">{{ $t('index.Featured_list') }}</p><h2>{{ topNav[activeNav] ? topNav[activeNav].name : $t('index.hot') }}</h2></div><span class="sl-count-tag">{{ videoCount || xuan_fei.length }}</span></div>
    <van-list v-model="loading" :finished="finished" :immediate-check="false" :finished-text="$t('video.no_more')" @load="onLoad"><div class="sl-media-grid"><article class="sl-media-card" v-for="(v,key) in xuan_fei" :key="key" @mouseenter="handleMouseEnter(key)" @mouseleave="handleMouseLeave(key)" @touchstart="handleTouchStart(key,$event)" @touchend="handleTouchEnd(key)"><van-image class="sl-media-cover" lazy-load :src="v.vod_pic" :class="{hide:playingVideo===key}"><template #loading><van-loading type="circular" /></template></van-image><video ref="videoRefs" :class="{'sl-media-cover sl-preview':true,show:playingVideo===key}" :src="v.vod_play_url || null" aria-hidden="true" preload="none" muted loop playsinline></video><div class="sl-media-shade"></div><span class="sl-media-badge"><span class="sl-live-dot"></span>{{ $t('index.hot') }}</span><span class="sl-media-viewers"><sl-icon name="user" />{{ v.vod_live_num || 0 }}</span><div class="sl-media-caption"><strong>{{ v.vod_name || v.vod_name_yn_yu || $t('No information yet') }}</strong><button type="button" class="sl-card-play" @touchstart.stop @click.stop="enterLiveRoom(v.id)" :aria-label="$t('history.play')"><sl-icon name="play" /></button></div></article></div></van-list>
  </div>
</main>
</template>

<script>
import axios from "axios";
export default {
  name: 'Home',
  data() {
    return {
      loggedIn: !!localStorage.getItem("token"),
      notice: this.$t("index.loading"),
      banners: [{}],
      basicData: [],
      gameitem: [{}, {}, {}, {}],
      movielist_0: [{}, {}, {}, {}],
      movielist_1: [{}, {}, {}, {}, {}, {}, {}, {}],
      isLoading: false,
      movielistSwiperOption: {
        slidesPerView: "auto",
        spaceBetween: 0,
        slidesPerGroup: 1,
      },
      bannerSwiperOption: {
        effect: "coverflow",
        grabCursor: true,
        centeredSlides: true,
        slidesPerView: "1",
        speed: 800,
        autoplay: {
          delay: 2000,
          disableOnInteraction: false,
        },
        coverflowEffect: {
          rotate: 50,
          stretch: 10,
          depth: 100,
          modifier: 1,
          slideShadows: true,
        },
      },
      xuan_fei: [],
      choose_page: 1,
      datalist: [],
      num: 4,
      hot_list: [], //热门列表
      recommend: [], //推荐列表
      testlist: [],
      // 顶部导航栏数据
      topNav: [],
      // 分类标签数据
      categories: [],
      // 状态数据
      activeNav: 0, // 默认选中附近
      activeCategory: 0, // 默认选中全部
      showCategories: false, // 分类标签显示状态（默认收起）
      // 直播列表数据
      videolitem: [],
      videoPage: 1,
      videoCount: 0,
      videoRequestId: 0,
      loading: false,
      finished: false,
      // 视频播放状态
      playingVideo: null,
      touchTimer: null,
    };
  },
  computed: {
    is_login() {
      return this.loggedIn;
    },
    visibleFeaturedList() {
      return Array.isArray(this.xuan_fei) ? this.xuan_fei.slice(0, 10) : [];
    },
    visiblePrivateList() {
      return Array.isArray(this.datalist)
        ? this.datalist.slice(0, this.num)
        : [];
    },
    indexNav() {
      return {
        1: {
          icon: "/img/index_nav/0.png",
          text: this.$t("foorter.subscribe"),
          path: "/Game",
        },
        2: {
          icon: "/img/index_nav/1.png",
          text: this.$t("bulletin"),
          path: "/Notice",
        },
        3: {
          icon: "/img/index_nav/2.png",
          text: this.$t("foorter.Film"),
          path: "/Video",
        },
        4: {
          icon: "/img/index_nav/3.png",
          text: this.$t("concubine.concubine"),
          path: "/Choose",
        },
      };
    },
    // 当前分类标签数据
    currentCategories() {
      // 根据当前选中的导航项返回对应的子分类
      if (!Array.isArray(this.topNav) || !this.topNav[this.activeNav]) {
        return [];
      }
      return this.topNav[this.activeNav].subItems || [];
    },
  },
  methods: {
    updateLoginState() {
      this.loggedIn = !!localStorage.getItem("token");
    },
    buildVideoNav(categories) {
      const excludedNames = ['观看直播', '觀看直播', '本地热门', '本地熱門'];
      const visible = (Array.isArray(categories) ? categories : []).filter((item) => !excludedNames.includes(String(item.name || '').trim())).map((item) => ({
        id: item.id,
        name: item.name,
        subItems: Array.isArray(item.children) ? item.children.filter((child) => !excludedNames.includes(String(child.name || '').trim())) : [],
      }));
      return [{ id: 'local_hot', name: '本地熱門', subItems: [] }, ...visible];
    },
    getActiveClassId() {
      const currentNav = this.topNav[this.activeNav];
      if (!currentNav) {
        return 0;
      }
      const currentChild = Array.isArray(currentNav.subItems)
        ? currentNav.subItems[this.activeCategory]
        : null;
      return currentChild && currentChild.id ? currentChild.id : currentNav.id;
    },
    resetHomeVideoState() {
      this.videoRequestId += 1;
      this.videoPage = 1;
      this.videoCount = 0;
      this.xuan_fei = [];
      this.loading = false;
      this.finished = false;
    },
    getVideoClass() {
      return this.$http({
        method: "get",
        url: "video_class",
      }).then((res) => {
        console.log("获取到的分类", res.data);
        const categories = Array.isArray(res.data) ? res.data : [];
        this.videolitem = categories;
        this.topNav = this.buildVideoNav(categories);
        if (!this.topNav.length) {
          this.activeNav = 0;
          this.activeCategory = 0;
          this.showCategories = false;
          return res;
        }
        if (!this.topNav[this.activeNav]) {
          this.activeNav = 0;
        }
        const currentNav = this.topNav[this.activeNav];
        this.activeCategory =
          currentNav.subItems && currentNav.subItems.length ? 0 : -1;
        this.showCategories = false;
        return res;
      });
    },
    getHomeVideoList() {
      const classId = this.getActiveClassId();
      if (!classId) {
        this.xuan_fei = [];
        this.videoCount = 0;
        return Promise.resolve();
      }
      const requestId = this.videoRequestId;
      const page = this.videoPage;
      const localHot = classId === 'local_hot';
      this.loading = true;
      return this.$http({
        method: "get",
        url: "video_list",
        data: {
          id: classId,
          page,
          limit: localHot ? 50 : 20,
          ...(localHot ? { mode: 'local_hot' } : {}),
        },
      }).then((res) => {
        if (requestId !== this.videoRequestId) return res;
        if (!res || res.code !== 200) throw new Error('Video list unavailable');
        const payload = res.data || {};
        const list = Array.isArray(payload.data) ? (localHot ? payload.data.slice(0, 50) : payload.data) : [];
        if (page === 1) {
          this.xuan_fei = list;
        } else {
          this.xuan_fei.push(...list);
        }
        this.videoCount = localHot ? list.length : Number(payload.count) || list.length || 0;
        this.finished = localHot || !list.length || this.xuan_fei.length >= this.videoCount;
        this.persistHomeData();
        return res;
      }).catch((error) => {
        if (requestId === this.videoRequestId) this.$toast('暫時無法載入視頻，請稍後重試');
        throw error;
      }).finally(() => {
        if (requestId === this.videoRequestId) this.loading = false;
      });
    },
    consumeRedirectTip() {
      const { redirect_tip, redirect_ts, ...restQuery } =
        this.$route.query || {};
      if (!redirect_tip) {
        return;
      }
      this.$nextTick(() => {
        if (redirect_tip === "contact_admin") {
          this.$toast(this.$t("reservation.contact_admin"));
        }
      });
      this.$router.replace({
        path: this.$route.path,
        query: restQuery,
      });
    },
    applyCachedHomeData() {
      const cache = localStorage.getItem("home_page_cache_tw");
      if (!cache) return false;
      try {
        const parsed = JSON.parse(cache);
        this.notice = parsed.notice || this.notice;
        this.banners =
          Array.isArray(parsed.banners) && parsed.banners.length
            ? parsed.banners
            : this.banners;
        this.xuan_fei = [];
        this.datalist = Array.isArray(parsed.datalist) ? parsed.datalist : [];
        this.hot_list = Array.isArray(parsed.hot_list) ? parsed.hot_list : [];
        this.recommend = parsed.recommend || this.recommend;
        return true;
      } catch (error) {
        return false;
      }
    },
    persistHomeData() {
      localStorage.setItem(
        "home_page_cache_tw",
        JSON.stringify({
          notice: this.notice,
          banners: this.banners,
          datalist: this.datalist,
          hot_list: this.hot_list,
          recommend: this.recommend,
        })
      );
    },
    kefu() {
    },
    // async getjiaodianlist() {
    //   try {
    //     const res = await axios.get(
    //       "https://admin.meetic168.us.cc/api/xuanfei/xuanfeilist",
    //       {
    //         params: {
    //           with_stats: 1,
    //           page: 1,
    //           plain_json: 1,
    //         },
    //       }
    //     );
    //     // console.log("拿到的数据", res);
    //     this.recommend = res.data.data.stats;
    //     this.persistHomeData();
    //     // console.log("111", this.recommend);
    //   } catch (err) { }
    // },
    // getxiaojielist() {
    //   return this.$http({
    //     method: "get",
    //     url: "xuanfeilist",
    //     data: {
    //       page: this.choose_page,
    //     },
    //   }).then((res) => {
    //     console.log('选妃列表',res.data);
    //     const list = Array.isArray(res.data) ? res.data : [];
    //     if (list.length > 0) {
    //       if (this.choose_page === 1) {
    //         this.datalist = list;
    //       } else {
    //         this.datalist.push(...list);
    //       }
    //       this.persistHomeData();
    //     } else {
    //       this.choose_page -= 1;
    //     }
    //   });
    // },
    profile(id) {
      this.$router.push({ path: "/profile?id=" + id });
    },
    // getxuanfeilist() {
    //   return this.$http({
    //     method: "get",
    //     url: "xuanfeilist",
    //     data: {
    //       is_ranking: 1,
    //     },
    //   }).then((res) => {
    //     console.log('小阶列表',res.data);
    //     this.xuan_fei = Array.isArray(res.data) ? res.data : [];
    //     this.hot_list = [];
    //     this.xuan_fei.forEach((v, i) => {
    //       if (v.is_hot == 1) {
    //         this.hot_list.push(v);
    //         // console.log("热门列表", this.hot_list);
    //       }
    //     });
    //     this.persistHomeData();
    //   });
    // },
    toServicePage() {
      const service = this.$store.getters.getBaseInfo;
      if (service.iskefu == 1) {
        window.location.href = service.kefu;
      }
    },
    nextList() {},
    toLottery(key, id) {
      if (!localStorage.getItem("token")) {
        this.$router.push({ path: "/Login" });
      } else {
        this.$router.push({ path: "/Lottery?key=" + key + "&id=" + id });
      }
    },
    toPlayVideo(id) {
      if (!localStorage.getItem("token")) {
        this.$router.push({ path: "/Login" });
      } else {
        this.$router.push({ path: "/profile?id=" + id });
      }
    },
    async onRefresh() {
      this.choose_page = 1;
      this.num = 4;
      this.datalist = [];
      this.resetHomeVideoState();
      try {
        await Promise.all([this.getBasicConfig(), this.getVideoClass()]);
        await this.getHomeVideoList();
        this.$toast(this.$t("reservation.refresh"));
      } finally {
        this.isLoading = false;
      }
    },
    getBasicConfig() {
      return this.$http({
        method: "get",
        url: "sys_config",
      }).then((res) => {
        // console.log('获取到的',res.data);
        this.basicData = res.data;
        this.getNotice(this.basicData);
        this.getBanner(this.basicData);
        this.getMovieList_0(this.basicData);
        this.getMovieList_1(this.basicData);
        this.persistHomeData();
        return this.getGameItem();
      });
    },
    getNotice(data) {
      this.notice = data.notice;
    },
    getGameItem() {
      return this.$http({
        method: "get",
        url: "lottery_hot",
      }).then((res) => {
        this.gameitem = res.data;
      });
    },
    getMovieList_0(data) {
      this.movielist_0 = data.movielist_0;
    },
    getMovieList_1(data) {
      this.movielist_1 = data.movielist_1;
    },
    getBanner(data) {
      this.banners = data.banners;
    },
    gotoMenu(index) {
      this.$router.push(index);
    },
    // 设置激活的导航项
    setActiveNav(index) {
      this.activeNav = index;
      const currentNav = this.topNav[index] || {};
      this.activeCategory =
        currentNav.subItems && currentNav.subItems.length ? 0 : -1;
      this.showCategories = false;
      this.resetHomeVideoState();
      this.getHomeVideoList().catch(() => {});
    },
    // 切换分类标签显示/隐藏
    toggleDropdown(index) {
      const currentNav = this.topNav[index];
      if (!currentNav || !currentNav.subItems || !currentNav.subItems.length) {
        return;
      }
      if (this.activeNav !== index) {
        this.activeNav = index;
        this.activeCategory = 0;
      }
      this.showCategories = !this.showCategories;
    },
    // 设置激活的分类标签
    setActiveCategory(index) {
      this.activeCategory = index;
      this.resetHomeVideoState();
      this.getHomeVideoList().catch(() => {});
    },
    // 加载更多
    onLoad() {
      if (this.finished || this.getActiveClassId() === 'local_hot') {
        this.loading = false;
        return;
      }
      this.loading = true;
      this.videoPage += 1;
      const requestId = this.videoRequestId;
      this.getHomeVideoList().then(() => {
        if (requestId !== this.videoRequestId) return;
        this.loading = false;
        if (this.xuan_fei.length >= this.videoCount) {
          this.finished = true;
        }
      }).catch(() => {
        if (requestId !== this.videoRequestId) return;
        this.loading = false;
        this.videoPage -= 1;
      });
    },
    // 进入直播间
    enterLiveRoom(id) {
      if (!localStorage.getItem("token")) {
        this.$router.push({ path: "/Login" });
        return;
      }
      this.$router.push({ path: "/PlayVideo", query: { id } });
    },
    // 检查视频是否可用
    isVideoAvailable(videoUrl) {
      // 简单检查视频URL是否存在
      return videoUrl && videoUrl.trim() !== "";
    },
    // 鼠标进入事件 - 开始播放视频
    handleMouseEnter(key) {
      const videoUrl = this.xuan_fei[key] && this.xuan_fei[key].vod_play_url;
      if (this.isVideoAvailable(videoUrl)) {
        this.playingVideo = key;
        // 播放视频
        const videoElement = this.$refs.videoRefs && this.$refs.videoRefs[key];
        if (videoElement) {
          videoElement.play().catch((err) => {
            console.log("视频播放失败:", err);
            // 播放失败时恢复显示封面图
            this.playingVideo = null;
          });
        }
      }
    },
    // 鼠标离开事件 - 停止播放视频
    handleMouseLeave(key) {
      this.playingVideo = null;
      // 暂停视频
      const videoElement = this.$refs.videoRefs && this.$refs.videoRefs[key];
      if (videoElement) {
        videoElement.pause();
      }
    },
    // 触摸开始事件 - 长按开始播放视频
    handleTouchStart(key, event) {
      const videoUrl = this.xuan_fei[key] && this.xuan_fei[key].vod_play_url;
      if (!this.isVideoAvailable(videoUrl)) {
        return;
      }
      // 清除之前的定时器
      if (this.touchTimer) {
        clearTimeout(this.touchTimer);
      }
      // 设置长按定时器
      this.touchTimer = setTimeout(() => {
        this.playingVideo = key;
        // 播放视频
        const videoElement = this.$refs.videoRefs && this.$refs.videoRefs[key];
        if (videoElement) {
          videoElement.play().catch((err) => {
            console.log("视频播放失败:", err);
            // 播放失败时恢复显示封面图
            this.playingVideo = null;
          });
        }
      }, 500); // 500ms触发长按
    },
    // 触摸结束事件 - 停止播放视频
    handleTouchEnd(key) {
      // 清除定时器
      if (this.touchTimer) {
        clearTimeout(this.touchTimer);
        this.touchTimer = null;
      }
      // 停止播放视频
      this.playingVideo = null;
      const videoElement = this.$refs.videoRefs && this.$refs.videoRefs[key];
      if (videoElement) {
        videoElement.pause();
      }
    },
  },
  created() {
    this.updateLoginState();
    this.consumeRedirectTip();
    this.applyCachedHomeData();
    this.getBasicConfig();
    this.getVideoClass().then(() => {
      this.resetHomeVideoState();
      return this.getHomeVideoList();
    }).catch(() => {});
  },
  activated() {
    this.updateLoginState();
  },
};
</script>
